import { render, staticRenderFns } from "./repairModuleRegin.vue?vue&type=template&id=22a6e79a&scoped=true"
import script from "./repairModuleRegin.vue?vue&type=script&lang=js"
export * from "./repairModuleRegin.vue?vue&type=script&lang=js"
import style0 from "./repairModuleRegin.vue?vue&type=style&index=0&id=22a6e79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6e79a",
  null
  
)

export default component.exports